<script lang="ts">
	import type { i18n } from 'types/common'

	import { getContext } from 'svelte'

	interface Props {
		value?: string | undefined
	}

	let { value = undefined }: Props = $props()

	const { t: translate } = getContext<i18n>('i18next')
</script>

{#if value}
	{value}
{:else}
	<i class="text-body-secondary">{translate('common:notSlashAcceptable', 'N/A')}</i>
{/if}
